window.addEventListener("load", function () {
  const swiper = new Swiper(".collection__products.swiper", {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: false,
    loop: false,
    noSwiping: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    scrollbar: {
      el: ".swiper-scrollbar",
    },
  });
});
